/* maré — shared behaviours for mare-* sections. No dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window && !reduce)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function initReveal(root) {
    (root || document).querySelectorAll('.m-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- theme cart bridge ---------- */
  // Broadcast's cart listens for `theme:cart:add` and reads the form around the button,
  // so the cart drawer, upsells and MonsterCart all behave exactly like the stock theme.
  function bindAddButtons(root) {
    (root || document).querySelectorAll('[data-m-add]').forEach(function (btn) {
      if (btn.__mBound) return;
      btn.__mBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: btn }, bubbles: false }));
      });
    });
  }

  /* ---------- horizontal track arrows ---------- */
  function initTracks(root) {
    (root || document).querySelectorAll('[data-m-track-wrap]').forEach(function (wrap) {
      if (wrap.__mBound) return;
      wrap.__mBound = true;
      var track = wrap.querySelector('[data-m-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-m-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth;
          track.scrollBy({ left: step * Number(b.getAttribute('data-m-dir')), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- product page ---------- */
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/<[^>]*>/g, '');
  }

  function initPdp(root) {
    (root || document).querySelectorAll('[data-m-pdp]').forEach(function (pdp) {
      if (pdp.__mBound) return;
      pdp.__mBound = true;

      var jsonEl = pdp.querySelector('[data-m-product-json]');
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = pdp.querySelector('[data-m-add]');
      var btnText = btn && btn.querySelector('.btn__text');
      var labels = JSON.parse(pdp.getAttribute('data-m-labels') || '{}');

      /* gallery */
      var slides = pdp.querySelector('[data-m-slides]');
      var thumbs = pdp.querySelectorAll('[data-m-thumb]');
      var dots = pdp.querySelectorAll('[data-m-dot]');
      var countEl = pdp.querySelector('[data-m-count]');
      var slideEls = slides ? slides.children : [];

      function goTo(index, instant) {
        if (!slides || !slideEls[index]) return;
        slides.scrollTo({ left: slideEls[index].offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
      }
      function setActive(index) {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        if (countEl) countEl.textContent = (index + 1) + ' / ' + slideEls.length;
        Array.prototype.forEach.call(slideEls, function (s, i) {
          var v = s.querySelector('video');
          if (v && i !== index) v.pause();
        });
      }
      function current() { return slides ? Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) : 0; }

      if (slides) {
        var t;
        slides.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { setActive(current()); }, 60); }, { passive: true });
        thumbs.forEach(function (th, i) { th.addEventListener('click', function () { goTo(i); }); });
        pdp.querySelectorAll('[data-m-gdir]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = current() + Number(b.getAttribute('data-m-gdir'));
            if (n < 0) n = slideEls.length - 1;
            if (n >= slideEls.length) n = 0;
            goTo(n);
          });
        });
      }

      /* variants */
      var optionInputs = pdp.querySelectorAll('[data-m-option]');
      function selectedOptions() {
        var out = [];
        pdp.querySelectorAll('[data-m-fieldset]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          out.push(c ? c.value : null);
        });
        return out;
      }
      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function markAvailability(opts) {
        pdp.querySelectorAll('[data-m-fieldset]').forEach(function (fs, pos) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = opts.slice(); test[pos] = inp.value;
            var v = findVariant(test);
            var chip = inp.nextElementSibling;
            if (chip) chip.classList.toggle('is-unavailable', !v || !v.available);
          });
          var sel = fs.querySelector('[data-m-selected]');
          var c = fs.querySelector('input:checked');
          if (sel && c) sel.textContent = c.value;
        });
      }
      function update(variant) {
        var price = pdp.querySelectorAll('[data-m-price]');
        var was = pdp.querySelectorAll('[data-m-was]');
        var save = pdp.querySelector('[data-m-save]');
        if (!variant) {
          if (btn) { btn.disabled = true; if (btnText) btnText.textContent = labels.unavailable || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        price.forEach(function (p) { p.textContent = money(variant.price); });
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        was.forEach(function (w) { w.textContent = onSale ? money(variant.compare_at_price) : ''; w.hidden = !onSale; });
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = (labels.save || 'Save') + ' ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
        }
        if (btn) {
          btn.disabled = !variant.available;
          if (btnText) btnText.textContent = variant.available ? (labels.add || 'Add to cart') : (labels.soldout || 'Sold out');
        }
        var sticky = pdp.querySelector('[data-m-sticky-btn]');
        if (sticky) sticky.disabled = !variant.available;

        if (variant.featured_media && slides) {
          var target = slides.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
          if (target) goTo(Array.prototype.indexOf.call(slideEls, target));
        }
        if (window.history && window.history.replaceState && pdp.hasAttribute('data-m-history')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        pdp.dispatchEvent(new CustomEvent('mare:variant', { detail: { variant: variant }, bubbles: true }));
      }
      optionInputs.forEach(function (inp) {
        inp.addEventListener('change', function () {
          var opts = selectedOptions();
          markAvailability(opts);
          update(findVariant(opts));
        });
      });
      if (optionInputs.length) markAvailability(selectedOptions());

      /* quantity */
      pdp.querySelectorAll('[data-m-qty]').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-step')));
            input.value = n;
          });
        });
      });

      /* UGC strip: autoplay muted in view, tap to (un)mute, one at a time */
      var ugcItems = pdp.querySelectorAll('[data-m-ugc]');
      if (ugcItems.length) {
        var ugcIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target.querySelector('video'); if (!v) return;
            if (e.isIntersecting && e.intersectionRatio > 0.6) { v.play().then(function(){ e.target.classList.add('is-playing'); }).catch(function(){}); }
            else { v.pause(); e.target.classList.remove('is-playing'); }
          });
        }, { threshold: [0, 0.6, 1] }) : null;
        ugcItems.forEach(function (item) {
          var v = item.querySelector('video'); if (!v) return;
          v.muted = true; v.setAttribute('playsinline', '');
          if (ugcIO) ugcIO.observe(item);
          item.addEventListener('click', function (ev) {
            ev.preventDefault();
            var wantSound = !item.classList.contains('is-unmuted');
            ugcItems.forEach(function (o) { if (o !== item) { var ov = o.querySelector('video'); if (ov) ov.muted = true; o.classList.remove('is-unmuted'); } });
            v.muted = !wantSound;
            item.classList.toggle('is-unmuted', wantSound);
            if (v.paused) v.play().then(function(){ item.classList.add('is-playing'); }).catch(function(){});
          });
        });
      }

      /* sticky mobile bar */
      var sticky = pdp.querySelector('[data-m-sticky]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        var sb = sticky.querySelector('[data-m-sticky-btn]');
        if (sb) sb.addEventListener('click', function () { btn.click(); });
      }
    });
  }

  /* ---------- MonsterCart drawer: inject trust footer on every render ---------- */
  function decorateCart() {
    var wrap = document.getElementById('monster-cart-wrapper');
    var tpl = document.getElementById('mare-cart-trust');
    if (!wrap || !tpl) return;
    var box = wrap.querySelector('#mu-checkout-container');
    if (!box || wrap.querySelector('[data-m-cart-trust]')) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    box.parentNode.insertBefore(node, box);
    var cont = node.querySelector('[data-m-cart-close]');
    if (cont) cont.addEventListener('click', function (e) {
      var close = wrap.querySelector('[aria-label="Close cart"]');
      if (close) { e.preventDefault(); close.click(); }
    });
  }
  function watchCart() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { decorateCart(); });
    mo.observe(document.body, { childList: true, subtree: true });
    decorateCart();
  }

  /* ---------- native cart drawer: ladder + upsell + count ---------- */
  function cartDrawerSync() {
    var d = document.querySelector('[data-cart-drawer].m-cd');
    if (!d) return;
    var count = 0, all = 0, ids = [];
    var giftPid = d.getAttribute('data-m-gift-product');
    d.querySelectorAll('[data-items-holder] [data-item]').forEach(function (it) {
      var q = it.querySelector('input[name="updates[]"]');
      var n = q ? (parseInt(q.value, 10) || 0) : 1;
      all += n;
      if (!giftPid || it.getAttribute('data-product-id') !== giftPid) count += n;
      if (it.getAttribute('data-product-id')) ids.push(it.getAttribute('data-product-id'));
    });
    var c = d.querySelector('[data-m-cart-count]');
    if (c) c.textContent = all > 0 ? '(' + all + ')' : '';

    var ladder = d.querySelector('[data-m-ladder]');
    if (ladder) {
      var txt = ladder.querySelector('[data-m-ladder-text]');
      var fill = ladder.querySelector('[data-m-ladder-fill]');
      var msg = '', pct = 0;
      if (count <= 0) { ladder.classList.add('is-hidden'); }
      else {
        ladder.classList.remove('is-hidden');
        var steps = parseInt(d.getAttribute('data-m-ladder-steps'), 10) || 3;
        if (count >= steps) { msg = d.getAttribute('data-m-tier-done'); pct = 100; }
        else if (count === 1) { msg = d.getAttribute('data-m-tier-1'); pct = 100 / steps; }
        else { msg = d.getAttribute('data-m-tier-2'); pct = 200 / steps; }
        ladder.classList.toggle('is-done', count >= steps);
        if (txt) {
          txt.innerHTML = msg;
          txt.style.fontSize = '';
          var fs = parseFloat(getComputedStyle(txt).fontSize) || 17;
          while (txt.scrollWidth > txt.clientWidth && fs > 12) { fs -= 0.5; txt.style.fontSize = fs + 'px'; }
        }
        if (fill) fill.style.width = pct + '%';
      }
    }

    var up = d.querySelector('[data-m-cart-upsell]');
    if (up) {
      var visible = 0;
      up.querySelectorAll('[data-m-up-product]').forEach(function (u) {
        var hide = ids.indexOf(u.getAttribute('data-m-up-product')) !== -1;
        u.classList.toggle('is-hidden', hide);
        if (!hide) visible++;
      });
      up.classList.toggle('is-hidden', count <= 0 || visible === 0);
      var hint = up.querySelector('[data-m-up-hint]');
      if (hint) {
        var hsteps = parseInt(d.getAttribute('data-m-ladder-steps'), 10) || 3;
        var key = count >= hsteps ? 'data-m-up-hint-3' : (count === 2 ? 'data-m-up-hint-2' : 'data-m-up-hint-1');
        var h = hint.getAttribute(key); if (h) hint.textContent = h;
      }
    }
  }
  function watchDrawer() {
    if (!document.querySelector('[data-cart-drawer].m-cd')) return;
    cartDrawerSync();
    document.addEventListener('theme:cart:change', function () { setTimeout(cartDrawerSync, 50); });
    document.addEventListener('theme:cart:open', function () { setTimeout(cartDrawerSync, 50); });
    document.addEventListener('theme:product:added', function () { setTimeout(cartDrawerSync, 50); });
    var holder = document.querySelector('[data-cart-drawer].m-cd [data-items-holder]');
    if (holder && 'MutationObserver' in window) new MutationObserver(function () { cartDrawerSync(); }).observe(holder, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('.m-cd input[name="updates[]"]')) setTimeout(cartDrawerSync, 400); });
  }


  /* ---------- free gift: keep the gift line in sync with the number of pieces ---------- */
  // Fall Edit: 2+ pieces = free Leblon Bracelet (separate hidden gift product, made free by an
  // automatic Buy X Get Y discount). We add it when the bag qualifies and remove it when it no longer does.
  var giftBusy = false, giftRuns = [];
  function giftCfg() {
    var el = document.querySelector('[data-m-gift-variant]');
    if (!el) return null;
    return { variant: Number(el.getAttribute('data-m-gift-variant')), product: Number(el.getAttribute('data-m-gift-product')), min: Number(el.getAttribute('data-m-gift-min')) || 2 };
  }
  function giftRefresh() {
    if (window.cart && typeof window.cart.getCart === 'function' && window.cart.cart) window.cart.getCart();
    else if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }
  function giftSync() {
    var cfg = giftCfg();
    if (!cfg || giftBusy) return;
    var now = Date.now();
    giftRuns = giftRuns.filter(function (t) { return now - t < 10000; });
    if (giftRuns.length >= 6) { // safety valve against loops: try again once the window clears
      clearTimeout(giftSync.__retry);
      giftSync.__retry = setTimeout(giftSync, Math.max(500, 10000 - (now - giftRuns[0])));
      return;
    }
    giftBusy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pieces = 0, gift = null;
        (cart.items || []).forEach(function (it) {
          if (it.product_id === cfg.product) { if (!gift) gift = it; }
          else pieces += it.quantity;
        });
        var req = null;
        if (pieces >= cfg.min && !gift) req = { url: 'cart/add.js', body: { items: [{ id: cfg.variant, quantity: 1 }] } };
        else if (pieces < cfg.min && gift) req = { url: 'cart/change.js', body: { id: gift.key, quantity: 0 } };
        else if (gift && gift.quantity > 1) req = { url: 'cart/change.js', body: { id: gift.key, quantity: 1 } };
        if (!req) return;
        giftRuns.push(Date.now());
        return fetch(root + req.url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(req.body) })
          .then(function () { giftRefresh(); });
      })
      .catch(function () {})
      .then(function () { giftBusy = false; });
  }
  function watchGift() {
    if (!giftCfg()) return;
    var t;
    var later = function () { clearTimeout(t); t = setTimeout(giftSync, 150); };
    document.addEventListener('theme:cart:change', later);
    document.addEventListener('theme:product:added', later);
    giftSync();
  }

  /* ---------- collection sort ---------- */
  function initSort(root) {
    (root || document).querySelectorAll('[data-m-sort]').forEach(function (sel) {
      if (sel.__mBound) return; sel.__mBound = true;
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString();
      });
    });
  }

  /* ---------- PDP trust line: visitor country + stock state ---------- */
  function initTrust(root) {
    (root || document).querySelectorAll('[data-m-trust]').forEach(function (box) {
      if (box.__mBound) return; box.__mBound = true;
      var country = box.querySelector('[data-m-country]');
      var stock = box.querySelector('[data-m-stock]');
      var line = box.querySelector('[data-m-ship]');
      // Shopify's own geolocation suggestion endpoint (no app, no IP lookup on our side)
      if (country) {
        var cached = null;
        try { cached = sessionStorage.getItem('mare:country'); } catch (e) {}
        if (cached) country.textContent = cached;
        else fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
            if (c && /^[A-Z]{2}$/.test(c)) { country.textContent = c; try { sessionStorage.setItem('mare:country', c); } catch (e) {} }
          }).catch(function () {});
      }
      var pdp = box.closest('[data-m-pdp]') || document;
      pdp.addEventListener('mare:variant', function (e) {
        var v = e.detail && e.detail.variant; if (!v || !stock || !line) return;
        var out = !v.available;
        line.classList.toggle('is-out', out);
        var rest = line.querySelector('[data-m-ship-rest]');
        if (rest) rest.hidden = out;
        stock.textContent = out ? stock.getAttribute('data-out') : (line.classList.contains('is-low') ? stock.getAttribute('data-low') : stock.getAttribute('data-in'));
      });
    });
  }

  /* ---------- product card colour swatches ---------- */
  // Clicking a dot swaps the card image to that variant's photo and syncs price, links and quick add.
  function initCardSwatches(root) {
    (root || document).querySelectorAll('[data-m-card]').forEach(function (card) {
      if (card.__mSwatch) return;
      var dots = card.querySelectorAll('[data-m-swatch]');
      if (!dots.length) return;
      card.__mSwatch = true;
      var img = card.querySelector('.m-card__img');
      var alt = card.querySelector('.m-card__alt');
      var price = card.querySelector('[data-m-card-price]');
      var links = card.querySelectorAll('[data-m-card-link]');
      var idInput = card.querySelector('[data-m-card-id]');
      var addBtn = card.querySelector('[data-m-add]');
      var addText = addBtn ? addBtn.querySelector('.btn__text') : null;
      var origSrc = img ? img.getAttribute('src') : '', origSet = img ? img.getAttribute('srcset') : '';
      var origPrice = price ? price.innerHTML : '';
      var origAdd = addText ? addText.textContent : '';
      var origHref = links.length ? links[0].getAttribute('href') : '';
      var token = 0;

      function swapImage(src, srcset) {
        if (!img || !src) return;
        if (img.getAttribute('src') === src) return;
        var t = ++token;
        var pre = new Image();
        pre.onload = function () {
          if (t !== token) return;
          img.style.opacity = '0';
          setTimeout(function () {
            if (t !== token) return;
            img.setAttribute('srcset', srcset || '');
            img.setAttribute('src', src);
            img.style.opacity = '';
          }, reduce ? 0 : 160);
        };
        pre.srcset = srcset || ''; pre.sizes = img.getAttribute('sizes') || '100vw'; pre.src = src;
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          dots.forEach(function (d) { d.classList.remove('is-active'); d.setAttribute('aria-pressed', 'false'); });
          dot.classList.add('is-active'); dot.setAttribute('aria-pressed', 'true');

          swapImage(dot.getAttribute('data-src'), dot.getAttribute('data-srcset'));
          var isDefault = dot.getAttribute('data-src') === origSrc;
          card.classList.toggle('m-card--swapped', !isDefault);

          var vid = dot.getAttribute('data-vid');
          var url = dot.getAttribute('data-url');
          links.forEach(function (a) { a.setAttribute('href', url || origHref); });
          if (idInput && vid) idInput.value = vid;

          if (price) {
            var p = Number(dot.getAttribute('data-price')), c = Number(dot.getAttribute('data-cmp'));
            if (p) price.innerHTML = (c > p ? '<s>' + money(c) + '</s>' : '') + money(p);
            else price.innerHTML = origPrice;
          }
          if (addBtn) {
            var avail = dot.getAttribute('data-avail') === '1';
            addBtn.disabled = !avail;
            if (addText) addText.textContent = avail ? 'Quick add · ' + (dot.getAttribute('data-label') || '') : 'Sold out';
          }
        });
      });
    });
  }

  function initAll(root) {
    initReveal(root);
    bindAddButtons(root);
    initTracks(root);
    initPdp(root);
    initSort(root);
    initCardSwatches(root);
    initTrust(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); watchCart(); watchDrawer(); watchGift(); });
  else { initAll(); watchCart(); watchDrawer(); watchGift(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
